// ======================================================================
// File Name       : DistributionOfferServiceSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button } from 'react-bootstrap';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';
import * as MessageTemplate from '../../constants/MessageTemplate';
import FormControlValidate from '../../components/FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import SelectBox from '../../components/SelectBox';

class DistributionOfferServiceSearch extends React.Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this);
  }
  onSearchBtnClick() {
    const isValid = this.validation();
    if (isValid) {
      this.props.onSearchBtnClick();
    }
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      institutionId,
      serviceName,
      offerType,
      handleChange,
      isEdit,
    } = this.props;
    this.refsToValidate = [];
    return (
      <div>
        <p className="margin-top-10">{isEdit ? '配布先のコンテンツまたはコースを指定してください' : '配布先のサービスとコンテンツまたはコースを指定してください'}</p>
        <Form onSubmit={(e) => {e.preventDefault(); this.onSearchBtnClick()}} className='form-horizontal'>
          {!isEdit ?
            <Form.Group
              className="form-info padding-left-15"
              controlId="formHorizontalDestinationServiceId"
            >
              <Col as={Form.Label} sm={3}>
                配布先サービスID
              </Col>
              <Col sm={6}>
                <FormControlValidate
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  type="text"
                  name="institutionId"
                  value={institutionId}
                  maxLength="64"
                  label="配布先サービスID "
                  validateType={VALIDATE_TYPE.ID}
                  onChange={handleChange}
                  messageError={MessageTemplate.MSG_ID_INVALID}
                  messageSuccess={MessageTemplate.MSG_ID_VALID}
                />
              </Col>
              <Col sm={3}>
                <Button variant="primary" className="btn-96 margin-left-20" type="submit">
                  サービス検索
                </Button>
              </Col>
            </Form.Group> : null}
          <Form.Group
            className="form-info padding-left-15"
            controlId="formHorizontalDestinationServiceName"
          >
            <Col as={Form.Label} sm={3}>
              配布先サービス名
            </Col>
            <Col sm={6}>
              <FormControl
                readOnly
                type="text"
                maxLength="256"
                name="serviceName"
                value={serviceName}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info padding-left-15" controlId="formHorizontalChoosenList">
            <Col as={Form.Label} sm={3} className="lable-content margin-top-10">
              配布種別
            </Col>
            <Col sm={6} className="margin-top-4">
              <SelectBox
                data={SELECT_BOX_DATA.DISTRIBUTION_OFFER_TYPE}
                name="offerType"
                value={offerType}
                onChange={handleChange}
              />
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}
export default DistributionOfferServiceSearch;
